var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 84,
    viewBox: "0 0 95 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.59769 80.0152L45.6529 1.91943C46.4039 0.524863 48.4421 0.524863 49.3003 1.91943L94.4628 80.0152C95.2137 81.4098 94.2483 83.1262 92.6391 83.1262H2.31408C0.704964 83.1262 -0.260506 81.4098 0.59769 80.0152Z",
    fill: "#FFC043"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1484 74.8662L47.4763 15.4362L81.8041 74.8662H13.1484Z",
    fill: "#BC8B2C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M47.477 60.4908C48.3352 60.4908 49.0861 60.8127 49.7298 61.4563C50.3734 62.1 50.6952 62.8509 50.6952 63.7091C50.6952 64.5673 50.3734 65.3182 49.7298 65.9618C49.0861 66.6055 48.3352 66.9273 47.477 66.9273C46.6188 66.9273 45.7606 66.6055 45.2243 65.9618C44.5806 65.3182 44.2588 64.5673 44.2588 63.7091C44.2588 62.8509 44.5806 62.1 45.2243 61.4563C45.8679 60.8127 46.6188 60.4908 47.477 60.4908ZM45.0097 57.7017L44.5806 34.6377H50.4807L49.9443 57.7017H45.0097Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerYellowIcon);
export default __webpack_public_path__ + "static/media/Danger_yellow_icon.571d368bc06109eedf95252d52d6f65a.svg";
export { ForwardRef as ReactComponent };